import { render, staticRenderFns } from "./SelectableIconCard.vue?vue&type=template&id=39e4bd14&scoped=true"
import script from "./SelectableIconCard.vue?vue&type=script&lang=ts"
export * from "./SelectableIconCard.vue?vue&type=script&lang=ts"
import style0 from "./SelectableIconCard.vue?vue&type=style&index=0&id=39e4bd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e4bd14",
  null
  
)

export default component.exports